import React from 'react';
import { Steps } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment'
import $ from '../../scripts/events'
import 'antd/dist/antd.css';
import request from '../../scripts/request';

const { Step } = Steps;
let $this;
let store;
const codeHomePage = {
    0: 'DictionariesXzdq'
};
const codeIndexPage = {
    0: 'DictionariesDwdm',
    1: 'DictionariesDwdmXq',
    2: 'DictionariesRydm',
    3: 'DictionariesKsRydm',
    4: 'DictionariesXtsz',
    5: 'DictionariesSjzd',
    6: 'DictionariesKsdm',
    7: 'DictionariesGlmk'
};
class ZDInitPage extends React.Component {
    constructor(props) {
        super(props);
        $this = this;
        store = this.props.store;
    }
    componentDidMount() {
        let _data = { init: true, total: 0 };
        if (store.topContainer.pageName === 'index') {
            _data = { mkid: store.topContainer.mkid, total: 7 };
        }
        setTimeout(() => {
            this.sjzdInitLoad(_data, 0);
        }, 1000);
    }

    componentWillMount() {

    }
    //字典初始化
    sjzdInitLoad = (_data, index) => {

        const { initDispatch } = $this.props;
        let _type = '';
        if (store.topContainer.pageName === 'homePage') {
            _type = codeHomePage[index];
            initDispatch({ type: 'homePageInit', data: { current: index, status: 'process' } });
        }
        else {
            _type = codeIndexPage[index];
            initDispatch({ type: 'indexPageInit', data: { current: index, status: 'process' } });
        }
        _data.tbName = _type;
        if (_type != undefined) {
            request({
                url: 'api/Index/SjzdInit',
                method: 'post',
                data: _data
            }).then(function (res) {
                if (res !== null && res !== undefined) {
                    let _result = {};
                    if (res.data.length >= 0) {
                        _result = res.data[0];
                    }
                    localStorage.removeItem(_type);
                    setTimeout(() => {
                        localStorage.setItem(_type, JSON.stringify(_result));//本地存储
                        initDispatch({ type: _type, data: _result });//store更新
                        let _resdata = { current: parseInt(index + 1), status: 'finish' };
                        if (index === 0) {
                            _resdata.description1 = res.message;
                        }
                        else if (index === 1) {
                            _resdata.description2 = res.message;
                        }
                        else if (index === 2) {
                            _resdata.description3 = res.message;
                        }
                        else if (index === 3) {
                            _resdata.description4 = res.message;
                        }
                        else if (index === 4) {
                            _resdata.description5 = res.message;
                        }
                        else if (index === 5) {
                            _resdata.description6 = res.message;
                        }
                        else if (index === 6) {
                            _resdata.description6 = res.message;
                        }
                        else if (index === 7) {
                            _resdata.description7 = res.message;
                        }
                        else if (index === 8) {
                            _resdata.description8 = res.message;
                        }
                        if (store.topContainer.pageName === 'homePage') {
                            initDispatch({ type: 'homePageInit', data: _resdata });
                        }
                        else {
                            initDispatch({ type: 'indexPageInit', data: _resdata });
                        }
                        if (index < _data.total) {
                            index++;
                            $this.sjzdInitLoad(_data, index);
                        }
                        else {
                            let _state = { homePageSuccess: true, homePageSuccessTime: moment().format('YYYYMMDD') };
                            if (store.topContainer.pageName === 'index') {
                                _state = { indexPageSuccess: true, indexPageSuccessTime: moment().format('YYYYMMDD') };
                                localStorage.setItem('indexPageSuccess', true);
                                localStorage.setItem('indexPageSuccessTime', moment().format('YYYYMMDD'));
                                localStorage.setItem('indexPageUpdateTime', moment().format('YYYYMMDD'));
                            }
                            else {
                                localStorage.setItem('homePageSuccess', true);
                            }
                            initDispatch({ type: 'DictionariesState', data: _state });//字典状态更新
                            $this.props.onCancel();//关闭初始化窗口
                        }
                    }, 100);
                }
            });
        }
    }

    render() {
        return (
            store.topContainer.pageName === 'homePage' ?
                <Steps direction="vertical" current={store.homePageInit.current} status={store.homePageInit.status}>
                    <Step title="行政区划(5-10分钟)" description={store.homePageInit.description1} />
                </Steps>
                :
                <Steps direction="vertical" current={store.indexPageInit.current} status={store.indexPageInit.status}>
                    <Step title="机构代码" description={store.indexPageInit.description1} />
                    <Step title="辖区机构代码" description={store.indexPageInit.description2} />
                    <Step title="系统配置" description={store.indexPageInit.description3} />
                    <Step title="数据字典" description={store.indexPageInit.description4} />
                    <Step title="机构人员" description={store.indexPageInit.description5} />
                    <Step title="科室人员" description={store.indexPageInit.description6} />
                    <Step title="科室代码" description={store.indexPageInit.description7} />
                    <Step title="功能模块" description={store.indexPageInit.description8} />
                </Steps>
        );
    }
}
//需要渲染什么数据
function mapStateToProps(state) {
    return {
        store: state
    }
}
//需要触发什么行为
function mapDispatchToProps(dispatch) {
    return {
        initDispatch: (parame) => dispatch(
            {
                type: parame.type, data: parame.data//注册码提交
            }
        )
    }
}
//连接组件
ZDInitPage = connect(mapStateToProps, mapDispatchToProps)(ZDInitPage)
export default ZDInitPage;